import axiosApi from '../api/axiosApi';
import {
  CONFIRM_DOCUMENT,
  DELETE_DOCUMENT,
  DELETE_MULTIPLE_DOCUMENTS,
  GET_ARCHIVED_DOCUMENTS,
  GET_DOCUMENT,
  GET_ZAHTJEVI,
  POST_UPLOAD,
  SEARCH_DOCUMENTS,
} from '../common/constants/constants';
import { DocumentConfirmation, SearchDocument } from '../common/types/types';

class ZahtjeviService {
  getZahtjevi() {
    return axiosApi.get(GET_ZAHTJEVI);
  }
  getArchivedZahtjevi() {
    return axiosApi.get(GET_ARCHIVED_DOCUMENTS);
  }
  addZahtjev(request: FormData) {
    return axiosApi.post(POST_UPLOAD, request);
  }
  getDocument(documentId: string | number) {
    return axiosApi.get(GET_DOCUMENT + '/' + documentId);
  }
  removeDocument(documentId: string | number) {
    return axiosApi.delete(DELETE_DOCUMENT + '/' + documentId + '/');
  }
  removeMultipleDocuments(documentsIds: Array<string | number>) {
    return axiosApi.post(DELETE_MULTIPLE_DOCUMENTS, { doc_ids: documentsIds });
  }
  searchDocuments(request: SearchDocument) {
    return axiosApi.post(SEARCH_DOCUMENTS, request);
  }
  confirmDocument(request: DocumentConfirmation) {
    return axiosApi.post(CONFIRM_DOCUMENT, request);
  }
}

export default new ZahtjeviService();
